import {useLayoutEffect, useRef, useState} from 'react';
import {createPortal} from 'react-dom';
import {observer} from 'mobx-react';

const Tooltip = observer(({content, visible, className = '', contentClassName = '', children}) => {
  const wrapper = useRef(null);
  const [hovered, setHovered] = useState(false);
  const [anchor, setAnchor] = useState(null);
  const isShown = !!content && (visible || hovered);

  useLayoutEffect(() => {
    setAnchor(isShown ? wrapper.current.getBoundingClientRect() : null);
  }, [isShown]);

  return (
    <div
      ref={wrapper}
      className={`Tooltip ${className}`}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      {children}
      {isShown && anchor && createPortal(
        <div
          className={`Tooltip-content ${contentClassName}`}
          style={{top: anchor.top - anchor.height * 0.3 + window.scrollY, left: anchor.left + anchor.width / 2 + window.scrollX}}
        >
          {content}
        </div>,
        document.body
      )}
    </div>
  );
});

export default Tooltip;
